var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDesk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "mvlor5pxua",
    width: "120.8%",
    height: "157.8%",
    x: "-10.4%",
    y: "-28.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#mvlor5pxua)",
    transform: "translate(-15 -105) translate(0 64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15 41)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.612,
    cy: 26.366,
    r: 26.156,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.753 2.753)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.858,
    cy: 23.613,
    r: 22.357,
    stroke: "#000",
    strokeWidth: 2.092
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDD344",
    d: "M13.181 14.749l9.516-3.61c.57-.216 1.206-.172 1.742.119l12.928 7.03c.338.185.463.608.28.946-.058.106-.142.195-.244.258l-8.628 5.397c-.694.434-1.577.424-2.26-.027l-13.47-8.88c-.322-.211-.41-.644-.199-.965.081-.123.198-.217.335-.268z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.395,
    d: "M7.929 15.001L19.795 10.799 37.794 20.888 27.062 27.532zM8.157 15.704L8.371 29.463"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.395,
    d: "M17.103 21.196L16.63 24.63",
    transform: "rotate(-7.853 16.867 22.913)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.395,
    d: "M27.896 28.131L26.249 38.35",
    transform: "rotate(-9.155 27.073 33.24)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.395,
    d: "M38.224 21.202L37.142 31.508",
    transform: "rotate(-9.155 37.683 26.355)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 3.487,
    d: "M2.919 22.53L45.263 24.964",
    transform: "rotate(-45 24.09 23.747)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2.092,
    d: "M0.765 22.582L46.425 25.364",
    transform: "rotate(-45 23.595 23.973)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDesk);
export default __webpack_public_path__ + "static/media/NoDesk.0c7a6199b297b71cd42d5bce9e140bdb.svg";
export { ForwardRef as ReactComponent };